import {
  MANAGEMENTS_SUBTYPE_UPDATE_POWERS_TEXT,
  MANAGEMENTS_SUBTYPE_UPDATE_GAS_FLOW_TEXT,
  MANAGEMENTS_SUBTYPE_UPDATE_HOLDER_TEXT,
  MANAGEMENTS_SUBTYPE_UPDATE_ADDRESS_TEXT,
  MANAGEMENTS_SUBTYPE_UPDATE_BANK_ACCOUNT_TEXT,
  MANAGEMENTS_SUBTYPE_CONTRACT_END_TEXT,
  MANAGEMENTS_SUBTYPE_UPDATE_CLAIM_TEXT,
  MANAGEMENTS_SUBTYPE_UPDATE_CONTACT_TEXT,
  SERVICES_SUBTYPE_OPTIMIZE_BILLS,
  SERVICES_SUBTYPE_OPTIMIZE_COVERAGES,
  SERVICES_SUBTYPE_OPTIMIZE_GAS,
  SERVICES_SUBTYPE_OPTIMIZE_POWER,
  MANAGEMENTS_REGISTER_TYPE_CLAIMS,
} from "../../../core/constants/constants";
import { OwnerDataCups } from "../../../core/models/ownerData/ownerData.model";
import {
  SuppliesCups,
  SuppliesTableRow,
} from "../../../core/models/supplies/supplies.model";
import { initialFiltersCifCups } from "../filterCifCups/filterCifCups.util";

const initialFiltersSupplies = {
  ...initialFiltersCifCups,
  location: null,
};

const localStorageSuppliesFilters =
  process.env.REACT_APP_LOCALSTORAGE_SUPPLIES_FILTERS!;
const removeLocalstorageSupplyFilters = () =>
  localStorage.removeItem(localStorageSuppliesFilters);
const getLocalstorageSupplyFilters = () =>
  localStorage.getItem(localStorageSuppliesFilters);

const refreshLocalstorageSupplyFilters = (suppliesFilters: object) =>
  localStorage.setItem(
    localStorageSuppliesFilters,
    JSON.stringify(suppliesFilters)
  );

const setLocalstorageSupplyFilters = (suppliesFilters: object) =>
  localStorage.setItem(
    localStorageSuppliesFilters,
    JSON.stringify(suppliesFilters)
  );

const formatSuppliesCups = (
  suppliesCups: SuppliesCups[]
): SuppliesTableRow[] => {
  return suppliesCups.map(
    ({
      Identidad,
      DireccionSuministro,
      DenominacionCliente,
      CodigoContrato,
      PoblacionCUPS,
      Tarifa,
      NumFacturas,
      Cups,
      IdCups,
      IdContrato,
      ContratoSituacion,
      FechaAlta,
      Entorno,
    }) => {
      return {
        id: IdCups,
        socialReason: DenominacionCliente || "-",
        cif: Identidad,
        suppliesDirection: DireccionSuministro,
        town: PoblacionCUPS || "-",
        rate: Tarifa,
        bills: { billsNumber: NumFacturas, cupId: IdCups },
        date: FechaAlta,
        envirorment: Entorno,
        cups: {
          cupCode: Cups,
          cupId: IdCups,
          contractId: IdContrato,
          contractState: ContratoSituacion,
          contractCode: CodigoContrato,
        },
      };
    }
  );
};

const filterOptions = (
  ownerDataCups: OwnerDataCups[],
  id: (keyof OwnerDataCups)[],
  returnValue: keyof OwnerDataCups,
  selectedItems: string[][]
): string[] =>
  ownerDataCups
    .filter((ownerDataCup) =>
      selectedItems.every((items, index) =>
        items.length
          ? items.some((item) => ownerDataCup[id[index]] === item)
          : true
      )
    )
    .filter((ownerDataCup) => ownerDataCup[returnValue])
    .map((ownerDataCup) => ownerDataCup[returnValue]);

const getTextCodeText = (recordTextType: string, claimTextSubType: string) =>
  recordTextType === MANAGEMENTS_REGISTER_TYPE_CLAIMS
    ? recordTextType
    : getTextCode(claimTextSubType).title;

const getTextCode = (
  managementText: string
): { title: string; icon: string } => {
  switch (managementText) {
    case MANAGEMENTS_SUBTYPE_UPDATE_POWERS_TEXT:
      return {
        title: "Modificacion de potencias",
        icon: "t-icon-electricite-big",
      };
    case MANAGEMENTS_SUBTYPE_UPDATE_GAS_FLOW_TEXT:
      return {
        title: "Modificación de caudal diario (Qd)",
        icon: "t-icon-gaz-big",
      };
    case MANAGEMENTS_SUBTYPE_UPDATE_HOLDER_TEXT:
      return {
        title: "Cambio de titular",
        icon: "t-icon-building",
      };
    case MANAGEMENTS_SUBTYPE_UPDATE_ADDRESS_TEXT:
      return {
        title: "Actualización Dirección de Correspondencia",
        icon: "t-icon-home",
      };
    case MANAGEMENTS_SUBTYPE_UPDATE_BANK_ACCOUNT_TEXT:
      return {
        title: "Cambio de domiciliación bancaria",
        icon: "t-icon-Bank",
      };
    case MANAGEMENTS_SUBTYPE_CONTRACT_END_TEXT:
      return {
        title: "Baja por cese de actividad",
        icon: "t-icon-power-off",
      };
    case MANAGEMENTS_SUBTYPE_UPDATE_CLAIM_TEXT:
      return {
        title: "Reclamación",
        icon: "t-icon-warning",
      };
    case MANAGEMENTS_SUBTYPE_UPDATE_CONTACT_TEXT:
      return {
        title: "Actualizar datos de contacto",
        icon: "t-icon-AddressBook",
      };
    case SERVICES_SUBTYPE_OPTIMIZE_POWER:
      return {
        icon: "t-icon-electricite-big",
        title: "Optimizador de potencias",
      };
    case SERVICES_SUBTYPE_OPTIMIZE_BILLS:
      return { icon: "t-icon-chart-bar", title: "Simulador de facturas" };
    case SERVICES_SUBTYPE_OPTIMIZE_GAS:
      return { icon: "t-icon-gaz-big", title: "Optimizador de caudal" };
    case SERVICES_SUBTYPE_OPTIMIZE_COVERAGES:
      return { icon: "t-icon-Bank", title: "Realizar coberturas" };
    default:
      return { title: "Otras gestiones", icon: "t-icon-warning" };
  }
};

export {
  initialFiltersSupplies,
  formatSuppliesCups,
  filterOptions,
  removeLocalstorageSupplyFilters,
  setLocalstorageSupplyFilters,
  refreshLocalstorageSupplyFilters,
  getLocalstorageSupplyFilters,
  getTextCode,
  getTextCodeText,
};
